import React from "react";

function Main() {
  return (
    <div>
      <div className="service-slider-sec w-100 float-left padding-top padding-bottom bg-dark-black">
        <div className="service-slider-box">
          <div
            id="owlsliderone"
            className="owl-carousel owl-theme index2-slider"
            data-aos="fade-up"
            data-aos-duration={600}
          >
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img1.png" alt="slider-img1" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img2.png" alt="slider-img2" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img3.png" alt="slider-img3" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img4.png" alt="slider-img4" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img5.png" alt="slider-img5" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img1.png" alt="slider-img1" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img2.png" alt="slider-img2" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img3.png" alt="slider-img3" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img4.png" alt="slider-img4" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img5.png" alt="slider-img5" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img1.png" alt="slider-img1" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img2.png" alt="slider-img2" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img3.png" alt="slider-img3" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img4.png" alt="slider-img4" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img5.png" alt="slider-img5" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img1.png" alt="slider-img1" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img2.png" alt="slider-img2" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img3.png" alt="slider-img3" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img4.png" alt="slider-img4" />
              </figure>
            </div>
            <div className="item">
              <figure className="mb-0">
                <img src="../assets/images/slider-img5.png" alt="slider-img5" />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
